import baseApi from '@store/api/baseApi';

export const favouritesApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getStyleExistingFolders: builder.query({
			query: (id) => ({
				url: `user/favourites/product/${id}/folders`
			}),
			providesTags: ['StyleExistingFolders']
		})
	})
});

export const { useGetStyleExistingFoldersQuery } = favouritesApi;
